// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vfhPA","col":"styles_col__3TJLk"};